import * as React from 'react';
export const IcSteeringWheel = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 2a10 10 0 100 20 10 10 0 000-20zM4.61 9a8 8 0 0114.78 0 1 1 0 01-.62 1.32 1 1 0 01-1.21-.58 6 6 0 00-11.08 0 1 1 0 01-1.21.58A1 1 0 014.61 9zm5.69 9.78a.998.998 0 01-1.3.61A8 8 0 014.61 15a1 1 0 01.62-1.33 1 1 0 011.21.58 6 6 0 003.26 3.26 1 1 0 01.6 1.24v.03zM8 12a4 4 0 118 0 4 4 0 01-8 0zm11.39 3A8 8 0 0115 19.39a1 1 0 01-1.33-.62 1 1 0 01.58-1.21 6 6 0 003.26-3.26 1 1 0 011.21-.58 1 1 0 01.67 1.28zM12 11a1 1 0 100 2 1 1 0 000-2z'
      fill='currentColor'
    />
  </svg>
);
